import React, { ReactNode } from 'react';

import { BrandProvider as ConstellationBrandProvider } from '@constellation/core';
import BosTheme from '@constellation/core/themes/bos';
import LloydsTheme from '@constellation/core/themes/lloyds';

import GlobalStyle from './GlobalStyle';

export enum Brand {
  BOS = 'bos',
  LLOYDS = 'lloyds',
}

type Theme = Record<string, unknown>;

const getTheme = (brand: Brand): Theme => {
  switch (brand) {
    case Brand.BOS: {
      return BosTheme;
    }
    case Brand.LLOYDS:
    default: {
      return LloydsTheme;
    }
  }
};

function BrandProvider({
  children,
  brand,
}: {
  brand: Brand;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <>
      <GlobalStyle />
      <ConstellationBrandProvider theme={getTheme(brand)}>
        {children}
      </ConstellationBrandProvider>
    </>
  );
}

export default BrandProvider;
